module.exports = __webpack_public_path__ + "img/alarm-o.f38e82df.svg";